export default __webpack_public_path__ + "static/media/006-Dachshund.a0d51e8d.svg";